import React from "react";
import { Route, Routes } from "react-router";
import { Home, Tech, NotFound } from "./pages";
import { Header, Footer } from "./components";

export default () => (
  <div className="app">
    <Header />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/tech" element={<Tech />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
    <Footer />
  </div>
);
